import { ApiModule, type PaginatedResponseData } from '@common/index';

export class TransactionApi extends ApiModule {
  protected endpoint = '/transaction';

  public async pageTransactions(params: any) {
    return this.api.post<PaginatedResponseData<any>, any>(
      `${this.endpoint}/page?page=${params.page}&size=${params.itemsPerPage}&sort=${params.sort ?? ''}&sort=${params.sort ?? ''}`,
      {
        ...params
      }
    );
  }
}
